import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent,
} from '@angular/material/sidenav';
import { RouterLink, RouterOutlet } from '@angular/router';
import { Media } from '@/app/core/media';
import { AdminSidebar } from '@/app/domains/admin/layout/ui/sidebar';
import { AdminFooter } from './ui/footer/footer';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'admin-layout',
  imports: [
    MatIconModule,
    MatButtonModule,
    RouterOutlet,
    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,
    AdminSidebar,
    RouterLink,
    AdminFooter,
    MatMenuModule,
  ],
  templateUrl: './layout.html',
})
export class AdminLayout {
  // Dependencies
  private media = inject(Media);

  // State
  protected isMobile = computed(() =>
    this.media.match(`(max-width: 1023px)`)()
  );
}
